import { FaGithub, FaLinkedin, FaEnvelope } from 'react-icons/fa';
import './Footer.css';

function Footer() {
  return (
    <footer>
      <div className="footer-content">
        <p className="footer-cta">Let's build something great.</p>

        <div className="social-links">
          <a
            href="https://linkedin.com/in/kgotsofalang-kakudi-822214230"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn"
          >
            <FaLinkedin size={22} />
          </a>
          <a
            href="https://github.com/FalangCodes"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="GitHub"
          >
            <FaGithub size={22} />
          </a>
          <a href="mailto:kgotsofalangkakudi@gmail.com" aria-label="Email">
            <FaEnvelope size={22} />
          </a>
        </div>

        <p className="footer-copy">© 2026 Kgotsofalang Kakudi</p>
      </div>
    </footer>
  );
}

export default Footer;
